"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[986],{

/***/ 7754:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ PrivateSaleModal_PrivateSaleModal)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./src/hooks/useCountdown.ts
var useCountdown = __webpack_require__(53743);
// EXTERNAL MODULE: ./src/helpers/modifiers/formatPrice.ts
var formatPrice = __webpack_require__(72160);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./local_modules/analytics/context/index.ts
var context = __webpack_require__(5649);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./src/modules/products/usePrivateSale.ts + 1 modules
var usePrivateSale = __webpack_require__(28733);
// EXTERNAL MODULE: ./src/modules/user/shownPopups/index.tsx + 2 modules
var shownPopups = __webpack_require__(86506);
// EXTERNAL MODULE: ./src/modules/priceSelection/index.tsx
var priceSelection = __webpack_require__(19792);
// EXTERNAL MODULE: ./src/components/feedback/PlainModal/PlainModal.tsx + 1 modules
var PlainModal = __webpack_require__(87586);
// EXTERNAL MODULE: ./src/components/feedback/ModalHero/ModalHero.tsx
var ModalHero = __webpack_require__(11214);
// EXTERNAL MODULE: ./src/components/feedback/ModalButtons/ModalButtons.tsx
var ModalButtons = __webpack_require__(95325);
// EXTERNAL MODULE: ./src/components/layout/AspectContainer/AspectContainer.tsx
var AspectContainer = __webpack_require__(39682);
// EXTERNAL MODULE: ./src/components/dataDisplay/Image/Image.tsx + 1 modules
var Image = __webpack_require__(85808);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/components/dataDisplay/Label/Label.tsx + 1 modules
var Label = __webpack_require__(10016);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var messages = __webpack_require__(21182);
// EXTERNAL MODULE: ./src/compositions/buttons/AddToButton/components/AddToCartButton/AddToCartButton.tsx
var AddToCartButton = __webpack_require__(45464);
;// CONCATENATED MODULE: ./src/compositions/modals/PrivateSaleModal/messages.tsx
/* harmony default export */ const PrivateSaleModal_messages = ({
    label: {
        en: "Private sale {time}"
    },
    labelWithoutTimer: {
        en: "Private sale"
    },
    title: {
        en: `{name}, <span class="text-gold-50">Priced at {price}</span>`
    },
    subTitle: {
        en: `Originally priced at <s class="text-gold-50">{price}</s>`
    }
});

;// CONCATENATED MODULE: ./src/compositions/modals/PrivateSaleModal/PrivateSaleModal.tsx

















const PrivateSaleModal = (param)=>{
    let { closeModal, name, priority, popupName } = param;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const { privateSale } = (0,usePrivateSale/* default */.Z)();
    const setPopupShown = (0,shownPopups/* useSetPopupShown */.aw)();
    const nodeRef = (0,react.useRef)(null);
    const { countdownMessage, isExpired } = (0,useCountdown/* default */.Z)({
        message: privateSale?.timeLeft > 2 * 24 * 60 * 60 * 1000 ? PrivateSaleModal_messages.labelWithoutTimer : PrivateSaleModal_messages.label,
        initialTime: privateSale.timeLeft,
        format: "HH:mm:ss",
        nodeRef
    });
    const analyticEventParams = (0,react.useMemo)(()=>({
            priority,
            content: "Private sale",
            link: links/* default */.ZP.privateSale,
            productId: privateSale.id,
            productGender: privateSale.gender,
            productFullName: privateSale.name,
            productPrice: privateSale.price,
            productCategory: "Bundle"
        }), [
        priority,
        privateSale
    ]);
    const addToButtonProps = (0,react.useMemo)(()=>{
        const { page, pageType } = (0,context/* getAnalyticsContext */.cV)();
        return {
            product: {
                productId: privateSale?.id,
                rebrandImage: null,
                image: privateSale?.image,
                name: privateSale?.name,
                tradingItemId: privateSale?.tradingItem.id,
                brand: null
            },
            metadata: {
                placement: "Private sale modal",
                page,
                pageType
            }
        };
    }, [
        privateSale
    ]);
    const handleClose = (0,react.useCallback)(()=>{
        setPopupShown(popupName);
        closeModal();
    }, [
        closeModal,
        setPopupShown,
        popupName
    ]);
    (0,react.useEffect)(()=>{
        if (isExpired === true) {
            closeModal();
        }
    }, [
        isExpired,
        closeModal
    ]);
    (0,react.useEffect)(()=>{
        (0,analytics/* track */.j)("Popup display", analyticEventParams);
    }, [
        analyticEventParams
    ]);
    const handleClick = (0,react.useCallback)(()=>{
        handleClose();
        const { link, ...params } = analyticEventParams;
        (0,analytics/* track */.j)("Popup click", {
            ...params,
            action: "Add to cart"
        });
    }, [
        analyticEventParams,
        handleClose
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(priceSelection/* PriceSelectionProvider */.CT, {
        channel: priceSelection/* priceChannels */.GW.privateSale,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PlainModal/* default */.ZP, {
            className: "bg-light-beige",
            closeButtonIcon: "32/close-in-circle",
            closeModal: handleClose,
            "data-testid": name,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalHero/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AspectContainer/* default */.Z, {
                        className: "mx-auto w-full max-w-464",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: privateSale.image
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex-1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            style: isMobile ? "h5" : "h4",
                            message: {
                                ...PrivateSaleModal_messages.title,
                                values: {
                                    name: privateSale.name,
                                    price: (0,formatPrice/* default */.Z)(privateSale.price, {
                                        removeZeroCents: true
                                    })
                                }
                            },
                            align: "center",
                            html: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            className: "mt-24",
                            style: "t5",
                            message: {
                                ...PrivateSaleModal_messages.subTitle,
                                values: {
                                    price: (0,formatPrice/* default */.Z)(privateSale.originalPrice, {
                                        removeZeroCents: true
                                    })
                                }
                            },
                            align: "center",
                            html: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.ZP, {
                            className: (0,clsx/* default */.Z)("left-0 top-0", isMobile ? "mt-32" : "mt-48"),
                            title: countdownMessage,
                            absolute: true,
                            bgColor: "gold-30",
                            textColor: "black",
                            style: "eye1",
                            indent: 56,
                            ref: nodeRef,
                            "data-testid": "timer"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            className: "mt-24",
                            style: "p2",
                            align: "center",
                            message: privateSale.description
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalButtons/* default */.Z, {
                    className: "mt-32",
                    withMargin: false,
                    tertiary: {
                        title: messages/* default */.Z.learnMore,
                        to: links/* default */.ZP.privateSale,
                        onClick: ()=>{
                            (0,analytics/* track */.j)("Private sale learn more click", {
                                placement: "Popup",
                                productId: privateSale.id,
                                productGender: privateSale.gender,
                                productFullName: privateSale.name,
                                productCategory: "Bundle",
                                productPrice: privateSale.price
                            });
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCartButton/* default */.Z, {
                        size: 56,
                        style: "primary",
                        width: 320,
                        fullWidth: isMobile,
                        withNotification: false,
                        withRedirectToCheckout: true,
                        onClick: handleClick,
                        ...addToButtonProps
                    })
                })
            ]
        })
    });
};
/* harmony default export */ const PrivateSaleModal_PrivateSaleModal = (PrivateSaleModal);


/***/ })

}]);